import { type Context, createContext, type Dispatch } from 'react';

import {
  PagePanelsState,
  PagePanelsReducerActions,
} from '../types/page-state.js';
import { DismissiblePagePanels } from '../types/shared-page-types.js';

/** @internal */
export interface PageContextProps {
  state: PagePanelsState;
  dispatch: Dispatch<PagePanelsReducerActions>;
  detailsDismissed: boolean;
  sidebarDismissed: boolean;
  setPanelDismissed: (name: DismissiblePagePanels, value: boolean) => void;
  isPanelDismissed: (name: DismissiblePagePanels) => boolean;
}

/**
 * The PageContext is used to get and set the current state of the side panels
 * and provides the dispatcher to register the panels with their initial state.
 * @internal
 */
export const PageContext: Context<PageContextProps> =
  createContext<PageContextProps>({
    state: {
      details: { controlled: false, breakpoint: -1 },
      sidebar: { controlled: false, breakpoint: -1 },
    },
    dispatch: () => null,
    detailsDismissed: true,
    sidebarDismissed: true,
    setPanelDismissed: () => null,
    isPanelDismissed: () => false,
  });
PageContext.displayName = 'PageContext';
